import moment from "moment";
import React, { useState } from "react";
import { Edit, Trash } from "react-feather";
import toast from "react-hot-toast";
import { Badge, Button, UncontrolledTooltip } from "reactstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import CustomDataTable from "../../../common/CustomDataTable/index.jsx";
import AllocationModal from "./AttendanceModel.jsx";
import {
  useGetAttendancesQuery,
  useDeleteAttendanceMutation,
} from "../../../redux/attendance.js";
import { useGetWorkplaceQuery } from "../../../redux/workplace.js";
import { useGetStaffsQuery } from "../../../redux/staff.js";

const MySwal = withReactContent(Swal);

const Attendance = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [deleteAttendance] = useDeleteAttendanceMutation();

  const handleConfirmDelete = (id, name) => {
    return MySwal.fire({
      title: `Delete Attendance ${name}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger ms-1",
      },
      buttonsStyling: false,
    }).then(async (result) => {
      if (result.value) {
        const responseStatus = await deleteAttendance(id);
        if (responseStatus) {
          toast.success("Attendance Has been Deleted.");
        }
      }
    });
  };

  const handleEditClick = (data) => {
    setSelectedRow(data);
    setIsModalVisible(true);
  };

  const columns = [
    {
      name: "Staff",
      sortField: "staff",
      minWidth: "200px",
      sortable: true,
      selector: (row) => row?.staff?.name,
    },
    {
      name: "Day",
      sortField: "Day",
      minWidth: "100px",
      sortable: true,
      selector: (row) => moment(row.checkIn).format("dddd"),
    },
    {
      name: "CheckIn Time",
      sortField: "CheckIn",
      minWidth: "150px",
      sortable: true,
      selector: (row) => moment(row.checkIn).format("DD MMM, hh:mm A"),
    },
    // {
    //   name: "Worked Hours",
    //   sortField: "Worked Hours",
    //   minWidth: "100px",
    //   sortable: true,
    //   selector: (row) => (
    //     <div className="text-truncate" style={{ minWidth: "250px" }}>
    //       {/* {moment(row.checkOut).diff(row.checkIn, "hours")} */}
    //       {moment(row.checkOut) - moment(row.checkIn).format("hh:mm")}
    //     </div>
    //   ),
    // },
    {
      name: "CheckOut Time",
      sortField: "CheckOut",
      minWidth: "150px",
      sortable: true,
      selector: (row) => {
        if (!row.checkOut) {
          return <div>N/A</div>;
        }
        return <div>{moment(row.checkOut).format("DD MMM, hh:mm A")}</div>;
      },
    },
    {
      name: "Worked Hours",
      sortField: "Worked Hours",
      minWidth: "100px",
      sortable: true,
      selector: (row) => {
        if (!row.checkOut || !row.checkIn) {
          return (
            <div className="text-truncate" style={{ minWidth: "250px" }}>
              N/A
            </div>
          );
        }

        const duration = moment.duration(
          moment(row.checkOut).diff(moment(row.checkIn))
        );
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();

        const displayWorkedHours = `${hours}h ${minutes}m`;

        return (
          <div className="text-truncate" style={{ minWidth: "250px" }}>
            {displayWorkedHours}
          </div>
        );
      },
    },
    {
      name: "Status",
      sortField: "status",
      minWidth: "100px",
      sortable: true,
      selector: (row) => (
        <Badge
          className="badge badge-pill"
          color={row.status === "Present" ? "success" : "danger"}
        >
          {row.status}
        </Badge>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex align-items-center permissions-actions">
          <Button
            id="update-btn"
            size="sm"
            color="transparent"
            className="btn btn-icon"
            onClick={() => handleEditClick(row)}
          >
            <Edit className="font-medium-2" />
            <UncontrolledTooltip placement="top" target="update-btn">
              Update
            </UncontrolledTooltip>
          </Button>
          <Button
            id="delete-btn"
            size="sm"
            color="transparent"
            className="btn btn-icon"
            onClick={() => handleConfirmDelete(row._id, row.staff.name)}
          >
            <Trash className="font-medium-2 text-danger" />
            <UncontrolledTooltip placement="top" target="delete-btn">
              Delete
            </UncontrolledTooltip>
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <CustomDataTable
        columns={columns}
        title="Attendance Information"
        fetchData={useGetAttendancesQuery}
        query={{}}
        searchFields={["name"]}
        populate={[
          {
            path: "staff",
            dir: "hrm/staffs",
            select: "name email address department",
          },
          {
            path: "createdBy",
            dir: "users",
            select: "username name",
          },
        ]}
        buttonLabel={"Check-in / Check out"}
        addButtonClick={() => setIsModalVisible(true)}
      />
      <AllocationModal
        selectedRow={selectedRow}
        show={isModalVisible}
        setShow={setIsModalVisible}
        setSelectedRow={setSelectedRow}
      />
    </div>
  );
};

export default Attendance;
